module.exports = __webpack_public_path__ + "img/logo-2.dd62b4ba.png";